import * as React from "react";
import styled from "styled-components";
import classnames from "classnames";

import { Metrics } from "../../vars";

const OverlayMenuItem: React.FC<any> = ({ children, className, href }) => (
  <a
    className={classnames("analytics-nav", className)}
    href={
      href.includes("my-account/home/update-plan/move-house.html")
        ? "javascript:void(0)"
        : href
    }
    onClick={() =>
      href.includes("my-account/home/update-plan/move-house.html")
        ? testTarget(href)
        : null
    }
  >
    {children}
  </a>
);

const testTarget = href => {
  if (
    global.adobe &&
    global.adobe.target &&
    typeof global.adobe.target.getOffer === "function" &&
    typeof global.adobe.target.applyOffer === "function"
  ) {
    global.adobe.target.getOffer({
      mbox: "MA-1",
      success: function(offer) {
        if (offer && offer.length) {
          global.adobe.target.applyOffer({
            mbox: "MA-1",
            selector: "body",
            offer: offer
          });
        } else {
          location.pathname = href;
        }
      },
      error: function(status, error) {
        console.error("Error on A/B testing....", status, error);
        location.pathname = href;
      }
    });
  }
};

export default styled(OverlayMenuItem)`
  display: block;
  padding: 22px ${Metrics.Padding.OVERLAY_MENU_ITEM_X}px;
  color: ${p => p.theme.colors.grey500};
  font-size: ${Metrics.FontSizes.OVERLAY_MENU_ITEM_TEXT}px;
  line-height: 24px;
  text-decoration: none;
  border-bottom: 1px solid ${p => p.theme.colors.grey100};

  .style--rebrand & {
    text-decoration: none;
  }

  &:hover,
  &:active {
    color: ${p => p.theme.colors.primary};
    text-decoration: none;
  }
`;
